import {CLEAR_STATE} from '../../../constants';
import {initialState, ACTION_PREFIX, ACTION_LOGIN, ACTION_ERROR} from '../constants';
import loginReducer from './login';
import dataReducer from './data';
import errorReducer from './error';

export default function (state = initialState, action) {

    if( action.type === CLEAR_STATE)
        return initialState;

    if( action.type.substr(0,ACTION_PREFIX.length) !== ACTION_PREFIX )
        return state;

    const apiAction = action.type.substr(ACTION_PREFIX.length);

    switch( apiAction ){

        case ACTION_LOGIN:
            return loginReducer(state, action);

        case ACTION_ERROR:
            return errorReducer(state, action);

        default:
            return dataReducer(state, action);
    }

}


// WEBPACK FOOTER //
// ./src/App/services/Api/reducers/index.js